import { Dispatch } from "react"

interface IRadionButton {
    label: string,
    value: string
}

type RadionButtonGroupProps = {
    radioButtons: IRadionButton[],
    name: string
    selectedValue: string,
    setValue: Dispatch<React.SetStateAction<string>>
}

export const RadionButtonGroup = ({ radioButtons, name, selectedValue, setValue}: RadionButtonGroupProps) => {
    if (radioButtons.length == 1) {
        return <div>{radioButtons[0].label}</div>
    }
    return (
        <>
            <div>
                {
                    radioButtons.map((item) => <div><input type="radio" value={item.value} name={name} checked={item.value === selectedValue} onChange={() => setValue(item.value)} /> {item.label} </div>)
                }
            </div>
            
        </>
    )
}